// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const OptionTradingStyle = {
    /// For non option instrument
    Undefined: -1,
    Premium: 0,
    Futures: 1,
    MarkToMarket: 2
}